// ROOT'un revize ettigi "Gecmiste Girilen Sure" persist eden history.
// Bir kaydin acilisinda GET_LATEST_PAST_OVERRIDE ile job+kanal icin en son
// override cekilir. Past hesabinda o override + sonrasi ay_sayisi toplami
// kullanilir.

export const GET_LATEST_PAST_OVERRIDE = `
  query GetLatestPastOverride($jobId: uuid!, $ciroKanali: String!) {
    revenue_past_overrides(
      where: {
        job_id: { _eq: $jobId },
        ciro_kanali: { _eq: $ciroKanali }
      },
      order_by: { created_at: desc },
      limit: 1
    ) {
      id
      job_id
      ciro_kanali
      override_months
      notes
      created_by
      created_at
    }
  }
`;

// History gorunumu (root revize ekrani icin sonraki asamada kullanilabilir).
export const GET_PAST_OVERRIDES_HISTORY = `
  query GetPastOverridesHistory($jobId: uuid!, $ciroKanali: String!) {
    revenue_past_overrides(
      where: {
        job_id: { _eq: $jobId },
        ciro_kanali: { _eq: $ciroKanali }
      },
      order_by: { created_at: desc }
    ) {
      id
      override_months
      notes
      created_by
      created_at
      creator { id first_name last_name }
    }
  }
`;
